"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class Subject {
  static subscribe(observer) {
    Subject.observers = Subject.observers.concat(observer);
  }
  static unsubscribe(filterFunc) {
    Subject.observers = Subject.observers.filter(filterFunc);
  }
  static notify(payload, filterFunc) {
    const emptyFunc = item => item;
    Subject.observers.filter(filterFunc || emptyFunc).forEach(observer => observer.callback.call(null, payload));
  }
}
Subject.observers = [];
var _default = exports.default = Subject;